import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { auth, sendPasswordReset } from "../firebase";
import Header from "../components/Header";

function Reset() {
  const [email, setEmail] = useState("");
  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (user) navigate("/dashboard");
    if (error) console.log(error);
  }, [user, loading, error, navigate]);

  return (
    <>
    {loading === false ? (
    
    <div className="d-flex align-items-center flex-column mb-0 px-3 splashscreen">
      <Header key="1" user={user}/>
      
      <h2 className="p-2">Login</h2>

      <div className="p-2 loginbox">
        <form className="login_form" onSubmit={(e) => sendPasswordReset(e,email)} >
          <input
            type="email"
            className="textbox form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="E-mail Address"
            required
          />
          <button
            type="submit"
            className="btn btn-primary mb-2 py-2"
          >
            Send password reset email
          </button>

          
          <div>
            
          </div>
        </form>
      </div>

      <div className="mt-auto pb-5 to_registration text-center">
        <div>Don't have an account?<br/><Link to="/register">Sign up now!</Link></div>
        <div className="footer mt-3">Privacy - Cookie Policy - Contacts</div>
      </div>
    </div>

    ) : (
      <div className="loadingscreen">
        <div className="loading spinner-border text-warning"></div>
      </div>
    ) }
    </>
  );
}

export default Reset;
